import request from '@/utils/request'


// 查询【请填写功能名称】列表
export function listSignLog(query) {
  return request({
    url: '/user/sign/log/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询【请填写功能名称】分页
export function pageSignLog(query) {
  return request({
    url: '/user/sign/log/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询【请填写功能名称】详细
export function getSignLog(data) {
  return request({
    url: '/user/sign/log/detail',
    method: 'get',
    params: data
  })
}

// 新增【请填写功能名称】
export function addSignLog(data) {
  return request({
    url: '/user/sign/log/add',
    method: 'post',
    data: data
  })
}

// 修改【请填写功能名称】
export function updateSignLog(data) {
  return request({
    url: '/user/sign/log/edit',
    method: 'post',
    data: data
  })
}

// 删除【请填写功能名称】
export function delSignLog(data) {
  return request({
    url: '/user/sign/log/delete',
    method: 'post',
    data: data
  })
}
